import styled from 'styled-components';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Label = styled.div<{ theme: Theme }>`
  display: inline-flex;
  align-items: center;
  ${getBodyStyle('graphikCond', { default: 'small' }, 'semiBold')};
  padding: 4px 8px;
  background-color: ${getColor('shadeBrandPrimary200')};
  text-transform: uppercase;
`;

export default Label;
